module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/pricing.svg?b7b3ddbf";